import { useState, useEffect } from 'react'
import datasetService from '../../../services/datasetService'
import { useParams } from 'react-router-dom';
import { PageTable, Header } from '/src/layouts/page';
import worksheetService from '../../../services/worksheetService';
import storage from '/src/utils/storage';
import { env } from '../../../../../var/env';
import IconButton from '/src/components/UI/Button/IconButton/IconButton';
import './StatementStatistic.css';
import StatementStatisticsGraph from './StatementStatisticsGraph';


const ColumnSection = ({ columns, graphColumn, onCardClick, datasetName }) => {
    return (
        <div className="ss-column-grid">
            {columns.map(column => (
                <ColumnCard
                    key={column.id}
                    column={column}
                    datasetName={datasetName}
                    graphColumn={graphColumn}
                    onClick={onCardClick}
                />
            ))}
        </div>
    );
};


const ColumnCard = ({ column, datasetName, graphColumn, onClick }) => {
    const [topValue, setTopValue] = useState(null);
    const [lowValue, setLowValue] = useState(null);
    const [topCount, setTopCount] = useState(0);
    const [lowCount, setLowCount] = useState(0);
    const { getDataset } = datasetService;

    useEffect(() => {
        const fetchStats = async () => {
            let page = 1;
            let allRows = [];
            while (true) {
                const result = await getDataset(decodeURI(datasetName), { page });
                if (!result?.[0]?.data) break;
                const rows = result[0].data;
                allRows = [...allRows, ...rows];
                if (rows.length < result[0].per_page) break;
                page++;
            }
            const counts = {};
            allRows.forEach(row => {
                const val = row[column.id];
                if (val == null || val === '') return;
                counts[val] = (counts[val] || 0) + 1;
            });
            const sorted = Object.entries(counts).sort((a, b) => b[1] - a[1]);
            if (sorted.length > 0) {
                setTopValue(sorted[0][0] !== '' ? sorted[0][0] : 'NULL');
                setTopCount(sorted[0][1]);
                setLowValue(sorted[sorted.length - 1][0] !== '' ? sorted[sorted.length - 1][0] : 'NULL');
                setLowCount(sorted[sorted.length - 1][1]);
            }
        };
        fetchStats();
    }, [column]);


    const token = storage('local').get('token');
    const companyId = storage('session').get('company').id;
    const exportUrl = env.REACT_APP_API_PATH + `/dataset/${datasetName}/export?token_auth=${token}&company=${companyId}&column=${encodeURIComponent(column.name)}`;

    return (
        <div className={`ss-column-card${graphColumn?.id === column.id ? ' active' : ''}`} onClick={() => onClick(column)}>
            <div className="ss-column-card-header">
                <div className="ss-column-card-name">{column.name}</div>
                <a href={exportUrl} rel="noopener noreferrer" title="Export" onClick={e => e.stopPropagation()}>
                    <IconButton className="icons_up main-iconButton profil_action main_add-button space_tableButton" icon="fas fa-file-export" title="Export column" />
                </a>
            </div>
            <div className="ss-column-card-type">{column.type || 'other'}</div>
            <hr className="ss-divider" />
            {topValue || lowValue ? (
                <>
                    <p className="ss-card-stat"><strong>Most frequent:</strong> {topValue ?? '-'} ({topCount})</p>
                    <p className="ss-card-stat"><strong>Least frequent:</strong> {lowValue ?? '-'} ({lowCount})</p>
                </>
            ) : (
                <p className="ss-card-stat muted">Not valid values</p>
            )}
        </div>
    );
};


const StatementStatistic = () => {
    const { name } = useParams();
    const { getColumns } = worksheetService;
    const { datasets } = storage().get('company');
    const dataset = datasets.find(d => d.name === name);
    const [columns, setColumns] = useState([]);
    const [graphColumn, setGraphColumn] = useState(null);

    useEffect(() => {
        const fetchColumns = async () => {
            const [res, error] = await getColumns(dataset.id);
            if (!error) {
                setColumns(res.data.filter(c => !c.deleted));
            }
        };
        fetchColumns();
    }, [name]);

    useEffect(() => {
        if (columns.length > 0 && !graphColumn) {
            setGraphColumn(columns[0]);
        }
    }, [columns]);

    return (
        <PageTable>
            <Header title={`${name} statistics`}></Header>
            <ColumnSection
                columns={columns}
                graphColumn={graphColumn}
                onCardClick={setGraphColumn}
                datasetName={name}
            />
            <StatementStatisticsGraph column={graphColumn} allColumns={columns} datasetName={name} />
        </PageTable>
    );
};

export default StatementStatistic;
